module.exports = __webpack_public_path__ + "img/futurecast-opendental-char.1984ce8c.svg";